import { log, LOG_LEVELS } from '../../../../common/config/app_logger';
import { generateUserProperties } from '../user_properties';

let eventsQueue = [];

const eventsWaitingOptimoveInit = ['session began', 'page visit'];

export const initOptimoveUser = (userId) => {
  if (window.optimoveSDK?.API && userId) {
    log(LOG_LEVELS.INFO, 'Optimove', `init Optimove user: ${ userId }`);
    window.optimoveSDK.API.setUserId(userId.toString());
  }
};

const saveEventToQueue = (eventName, eventParams) => {
  log(LOG_LEVELS.INFO, 'Optimove', `saving event to queue ${ eventName }, params:`, eventParams);
  eventsQueue.push({ eventName, params: eventParams });
};

export const trackQueuedOptimoveEvents = () => {
  if (eventsQueue.length === 0) return;
  eventsQueue.forEach((event) => {
    const { eventName, params } = event;
    const userProps = generateUserProperties();
    log(LOG_LEVELS.INFO, 'GTM', `track queued event: ${ eventName }`);
    log(LOG_LEVELS.DEBUG, 'GTM', 'eventProperties', { ...params, ...userProps });
    window.dataLayer.push({
      event: eventName,
      ...userProps,
      ...params
    });
  });
  eventsQueue = [];
};

export const trackGTMEvent = (eventName, eventProperties) => {
  window.dataLayer = window.dataLayer || [];
  if ((!window.optimoveSDK || window.optimoveSDK === undefined) && eventsWaitingOptimoveInit.includes(eventName)) {
    saveEventToQueue(eventName, eventProperties);
  } else {
    const userProps = generateUserProperties();
    log(LOG_LEVELS.INFO, 'GTM', `track event: ${ eventName }`);
    log(LOG_LEVELS.DEBUG, 'GTM', 'eventProperties', { ...eventProperties, ...userProps });
    window.dataLayer.push({
      event: eventName,
      ...userProps,
      ...eventProperties
    });
  }
};

const checkOptimoveUserId = ({ eventName, params }) => {
  let optimoveSDKAPIGetUserId = window.optimoveSDK?.API.getUserId();
  if (!optimoveSDKAPIGetUserId) {
    const interval = setInterval(() => {
      optimoveSDKAPIGetUserId = window.optimoveSDK?.API.getUserId();
      if (optimoveSDKAPIGetUserId) {
        trackGTMEvent(eventName, params);
        clearInterval(interval);
      }
    }, 1000);
  }
};

export const trackPageVisit = (pageTitle, withUserId = false) => {
  const eventName = 'page visit';
  const optimoveUserId = window.optimoveSDK?.API.getUserId();
  const params = { url: window.location.href, 'page title': pageTitle };
  log(LOG_LEVELS.INFO, 'Optimove', `track page visit: ${ pageTitle }`);
  if (withUserId && !optimoveUserId) {
    checkOptimoveUserId({ eventName, params });
    return;
  }
  trackGTMEvent(eventName, params);
};
